import { render, staticRenderFns } from "./GetInfo.vue?vue&type=template&id=973c22f2"
import script from "./GetInfo.vue?vue&type=script&lang=js"
export * from "./GetInfo.vue?vue&type=script&lang=js"
import style0 from "./GetInfo.vue?vue&type=style&index=0&id=973c22f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports